import { AGENT_TYPES } from './agentTypes';

export const WORK_HONESTLY_MESSAGES: { [key in AGENT_TYPES]: string } = {
  [AGENT_TYPES.Agency]: 'Документы агентства проверены',
  [AGENT_TYPES.Company]: 'Документы компании проверены',
  [AGENT_TYPES.Agent]: 'Документы агента проверены',
};
